module.exports = __webpack_public_path__ + "static/media/1.818b447f.jpg";